import { useContext } from "react";

import "./App.css";
import CodingWindow from "./Componets/CodingWindow/CodingWindow";

import Header from "./Componets/Header/Header";
import InitialLook from "./Componets/InitialLook/InitialLook";

import StoreContext from "./Store/code-context";

export default function App() {
  const storeCtx = useContext(StoreContext);

  return (
    <>
      <Header />
      {!storeCtx.File && <InitialLook />}
      {storeCtx.File && <CodingWindow />}
    </>
  );
}
